export const tradErrors = function (message: string) {
    switch (message) {
        case 'This value should not be blank.':
            return 'Ce champ ne doit pas être vide';
        default:
            return message;
    }
};
